import React from "react";
import { motion } from "framer-motion";
import {
  BrainCircuit,
  Puzzle,
  Shield,
  Server,
  Rocket,
  BadgeDollarSign,
  Headphones,
  Trophy,
  type LucideIcon,
} from "lucide-react";
import AnimatedSection from "./AnimatedSection";
import SectionHeader from "./SectionHeader";

type Reason = {
  title: string;
  description: string;
  icon: LucideIcon;
};

const reasons: Reason[] = [
  { title: "AI Specialists", description: "Expert team with deep NLP and conversational AI experience.", icon: BrainCircuit },
  { title: "Customized Solutions", description: "Tailored chatbots built around your workflows and brand.", icon: Puzzle },
  { title: "Secure Architecture", description: "Enterprise-grade security with encrypted data handling.", icon: Shield },
  { title: "Scalable Infrastructure", description: "Handle thousands of conversations without downtime.", icon: Server },
  { title: "Fast Deployment", description: "Go live in weeks, not months, with agile delivery.", icon: Rocket },
  { title: "Affordable Pricing", description: "Premium AI solutions at competitive, transparent rates.", icon: BadgeDollarSign },
  { title: "Dedicated Support", description: "Ongoing maintenance, updates, and expert assistance.", icon: Headphones },
  { title: "Proven Results", description: "Track record of measurable ROI across industries.", icon: Trophy },
];

const ChatBotWhyChoose: React.FC = () => (
  <AnimatedSection as="section" className="cbot-section cbot-section--alt" aria-labelledby="cbot-why-title">
    <div className="cbot-container">
      <SectionHeader
        eyebrow="Why Choose WebTech"
        title="Your Trusted AI Chatbot Development Partner"
        text="We combine cutting-edge AI technology with business-focused strategy to deliver chatbots that actually perform."
      />

      <div className="cbot-why-grid">
        {reasons.map((reason, index) => {
          const Icon = reason.icon;
          return (
            <motion.article
              key={reason.title}
              className="cbot-why-card"
              initial={{ opacity: 0, scale: 0.96 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: index * 0.05 }}
              whileHover={{ y: -6 }}
            >
              <div className="cbot-why-card__icon">
                <Icon size={22} aria-hidden="true" />
              </div>
              <h3>{reason.title}</h3>
              <p>{reason.description}</p>
            </motion.article>
          );
        })}
      </div>
    </div>
  </AnimatedSection>
);

export default ChatBotWhyChoose;
